import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardActionArea from '@mui/material/CardActionArea';
import UnknowImage from "../../../Assets/unknown-image.png"
export default function ImageCard({ image }) {
    return (
        <Card sx={{ maxWidth: 160, boxShadow: 'none' }}>
            <CardActionArea>
                <CardMedia
                    component="img"
                    height="180"
                    image={image ? image : UnknowImage}
                    alt="green iguana"
                />
            </CardActionArea>
        </Card>
    );
}
